import { createPortal } from 'react-dom';
import { Button } from '../../../components/common/Button';

interface Props {
  /** 例: "Amazonのメイン画像を差し替えますか？" */
  title: string;
  originalUrl: string | null;
  newUrl: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * 画像差替の確認モーダル (現在の画像 → 新しい画像のプレビュー比較)。
 * Amazon / マニュアル商品詳細ページで共用する。body 直下に portal で描画する。
 */
export function ReplaceConfirmDialog({ title, originalUrl, newUrl, onConfirm, onCancel }: Props) {
  return createPortal(
    <div className="replace-confirm-overlay" onClick={onCancel}>
      <div className="replace-confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <p className="replace-confirm-title">{title}</p>
        <div className="replace-confirm-images">
          <div className="replace-confirm-image-box">
            <span className="replace-confirm-image-label">現在の画像</span>
            {originalUrl ? (
              <img src={originalUrl} alt="現在の画像" />
            ) : (
              <div className="replace-confirm-empty">画像なし</div>
            )}
          </div>
          <div className="replace-confirm-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </div>
          <div className="replace-confirm-image-box">
            <span className="replace-confirm-image-label">新しい画像</span>
            <img src={newUrl} alt="新しい画像" />
          </div>
        </div>
        <div className="replace-confirm-buttons">
          <Button type="button" variant="muted" size="md" onClick={onCancel}>
            キャンセル
          </Button>
          <Button type="button" variant="primary" size="md" onClick={onConfirm}>
            差し替える
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}
